import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const Image = ({ src, alt, errorSrc, ...otherProps }) => {
    const [source, setSource] = useState(src);

    useEffect(() => {
        if (source !== errorSrc) {
            setSource(src);
        }
    });

    function handleLoadError() {
        setSource(errorSrc);
    }

    return <img {...otherProps} onError={handleLoadError} src={source} alt={alt} />;
};

Image.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    errorSrc: PropTypes.string.isRequired
};

export default Image;
